import { Controller } from "stimulus";
import { EventToast } from "../events";

export default class extends Controller {
  static targets = ["notice", "notification"];

  connect() {
    window.addEventListener(EventToast, e => {
      this.noticeTarget.innerHTML = e.detail.notice;
    });
  }
}
